import { crisisResources } from '../data/supportResources';

function CrisisResources() {
  return (
    <section className="surface-card crisis-card">
      <p className="tag">Crisis resources</p>
      <h2>Use emergency support for urgent danger.</h2>
      <p className="muted">Problems is peer support and autobiography context. It is not emergency care, therapy, or professional advice.</p>
      <div className="crisis-grid">
        {crisisResources.map((resource) => (
          <article className="mini-card" key={resource.title}>
            <strong>{resource.title}</strong>
            <p>{resource.text}</p>
            {resource.href ? <a className="button button-secondary button-small" href={resource.href} target="_blank" rel="noreferrer">Open resource</a> : null}
          </article>
        ))}
      </div>
    </section>
  );
}

export default CrisisResources;
